import React from 'react'
import App from './App'
import reactDom from 'react-dom'
import './style.css'
reactDom.render(<App/>,document.getElementById('root'))